import React, { useState, useEffect } from 'react'

export interface CheckboxProps extends React.HTMLProps<HTMLInputElement> {
  /**
   * If `true`, the checkbox will be disabled.
   * @default "false"
   */
  isDisabled?: boolean
  /**
   * If `true`, the checkbox will be disabled.
   * @default "false"
   */
  isChecked?: boolean
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  (props, ref) => {
    const {
      type = 'checkbox',
      isDisabled = false,
      isChecked = false,
      id,
      name,
      // eslint-disable-next-line
      onClick = () => {},
      // eslint-disable-next-line
      onChange = () => {},
      ...rest
    } = props
    const [checked, setChecked] = useState(isChecked)

    useEffect(() => {
      setChecked(isChecked)
    }, [isChecked])

    const checkedStyle = checked ? 'border-flamingo' : 'border-gray'
    const borderStyle = isDisabled ? 'border-gray-100' : checkedStyle
    const svgDisabledStyle = isDisabled ? 'text-gray-100' : 'text-flamingo'

    return (
      <div className="items-center">
        <div
          className={`bg-white border rounded ${borderStyle} w-4 h-4 flex flex-shrink-0 justify-center items-center mr-2`}
        >
          <input
            ref={ref}
            type={type}
            role="checkbox"
            aria-checked={isChecked}
            disabled={isDisabled}
            checked={checked}
            name={name}
            id={id}
            className="opacity-0 absolute"
            onClick={(e) => {
              setChecked(!checked)
              onClick(e)
            }}
            onChange={onChange}
            {...rest}
          />
          <svg
            className={`fill-current ${
              !checked ? 'hidden' : ''
            } w-2 h-2 ${svgDisabledStyle} pointer-events-none`}
            viewBox="0 0 20 20"
          >
            <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
          </svg>
        </div>
      </div>
    )
  }
)
